import * as Yup from "yup";

export const getFields = () => ({

    'email': {
        'label': 'loginFormEmail',
        'variant': 'outlined'
    },
    'password': {
        'label': 'loginFormPassword',
        'variant': 'outlined',
        'type':'password'
    },
});



export const fieldsInitialValues = () => {
    const fields = getFields();
    const initialValues = {};
    const keys = Object.keys(fields);
    const values = Object.values(fields);
    for (let i = 0; i < keys.length; i += 1) {
        initialValues[keys[i]] = ('default' in values[i] ? values[i].default : '');
    }
    return initialValues;
}

export const fieldsValidationSchema = () => {
    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Email must be a valid email address').required('Email is required'),
        password: Yup.string().required('Password is required')
    });
    return validationSchema;
}